const schema = {
    contracts: {
        id: 'contracts',
        label: 'Contrato(s) selecionado(s)',
        placeholder: '',
        type: 'select',
        required: true,
    },
    contractsGroup: {
        id: 'contractsGroup',
        label: 'Grupo(s) de Contrato(s) selecionado(s)',
        placeholder: '',
        type: 'select',
        required: false,
    },
    tipoSelecao: {
        id: 'tipoSelecao',
        label: 'Tipo de resultado',
        required: true,
        disabled: false,
        type: 'radio',
        value: '1',
        lookup: 'Contrato(s)',
        options: [
            {
                codigo: '1',
                nome: 'Por contrato',
            },
            {
                codigo: '2',
                nome: 'Por grupo de contrato',
            },
        ],
    },
    tipoRelatorio: {
        id: 'tipoRelatorio',
        label: 'Tipo de relatório',
        required: true,
        disabled: false,
        type: 'radio',
        value: '',
        lookup: 'Extrato de beneficiários(.pdf)',
        base64Header: 'application/pdf',
        options: [
            {
                codigo: '1',
                nome: 'Extrato de beneficiários(.pdf)',
                base64Header: 'application/pdf',
            },
            {
                codigo: '3',
                nome: 'Bate cadastral(.txt)',
                base64Header: 'text/plain',
            },
        ],
    },
    date: {
        id: 'date',
        label: 'Data',
        value: null,
        type: 'date',
        required: true,
    },
    competence: {
        id: 'competence',
        label: 'Competência',
        placeholder: '',
        type: 'date',
        required: false,
    },
    nf: {
        id: 'nf',
        label: 'N° da nota fiscal',
        placeholder: '',
        type: 'text',
        required: false,
    },
    status: {
        id: 'status',
        label: 'Situação de beneficiários',
        type: 'radio',
        value: '',
        required: true,
        options: [
            { codigo: 'Ativo', nome: 'Ativos' },
            { codigo: 'Excluido', nome: 'Inativos' },
            { codigo: 'Ambas', nome: 'Ambas' },
        ],
    },
};

export default schema;
